import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { promotionKeys, type ReportFilters } from "./query-keys";

/** GET /v1/promotion-report — quota/used/remaining per gift SKU. */
export function usePromotionReport(filters?: ReportFilters) {
  return useQuery({
    queryKey: promotionKeys.report(filters),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/promotion-report", {
        params: { query: filters ?? {} },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
